export const faEnvelopeDotClassic = [
  '576 512',
  '<path d="M496 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 64l289 0c-.7 5.2-1 10.6-1 16 0 56.9 37.1 105 88.3 121.7L316.8 306.4c-17.1 12.8-40.5 12.8-57.6 0l-208-156C39.1 141.3 32 127.1 32 112 32 85.5 53.5 64 80 64zM345.6 344.8L536.9 201.3c2.4-.8 4.8-1.7 7.1-2.6L544 384c0 35.3-28.7 64-64 64L96 448c-35.3 0-64-28.7-64-64l0-188 198.4 148.8c34.1 25.6 81.1 25.6 115.2 0z"/>'
]
